export function TypingIndicator() {
  return (
    <div className="flex items-start gap-3 px-4 py-2">
      <div className="w-7 h-7 rounded-full bg-[var(--color-primary-light)] flex items-center justify-center shrink-0">
        <span className="text-[10px] font-bold text-[var(--color-primary)]">IA</span>
      </div>
      <div className="bg-[var(--color-primary-subtle)] rounded-2xl rounded-tl-sm px-4 py-3">
        <span className="flex gap-1.5 items-center h-4">
          <span
            className="w-2 h-2 rounded-full bg-[var(--color-primary)] opacity-60"
            style={{ animation: 'bounce 1s ease-in-out 0s infinite' }}
          />
          <span
            className="w-2 h-2 rounded-full bg-[var(--color-primary)] opacity-60"
            style={{ animation: 'bounce 1s ease-in-out 0.2s infinite' }}
          />
          <span
            className="w-2 h-2 rounded-full bg-[var(--color-primary)] opacity-60"
            style={{ animation: 'bounce 1s ease-in-out 0.4s infinite' }}
          />
        </span>
      </div>
    </div>
  )
}
